import "./styles.scss";
import { Fragment, ReactElement } from "react";
import { AnnotationActions, AnnotationColors, AnnotationTypes } from "../../../shared/constants";
import { IAnnotationData } from "../../../shared/types";
import { RendererTypes } from "@bronte/viewer-api/src/main";
interface IAnnotationContextMenu {
  onAnnotationResponse: (annotation: IAnnotationData) => void;
  toggleFlashcardPopup: (visibility: boolean) => void;
  toggleNotesPopup: (visibility: boolean) => void;
  hideAnnotationMenu: () => void;
  annotation: IAnnotationData;
  renderer: RendererTypes;
}

export const AnnotationContextMenu = ({
  annotation,
  onAnnotationResponse,
  toggleFlashcardPopup,
  toggleNotesPopup,
}: IAnnotationContextMenu): ReactElement => {
  const saveAnnotation = (annotation: IAnnotationData): void => {
    onAnnotationResponse(annotation);
  };

  const setAnnotationColor = (color = ""): void => {
    annotation.color = color;
    annotation.annotationType = AnnotationTypes.Highlight;
    annotation.actionType = annotation.annotationId
      ? AnnotationActions.Edit
      : AnnotationActions.Add;

    saveAnnotation(annotation);
  };

  const deleteAnnotation = (): void => {
    annotation.color = "";
    annotation.actionType = AnnotationActions.Delete;

    saveAnnotation(annotation);
  };

  const openNewFlashcardPopup = (): void => {
    toggleFlashcardPopup(true);
  };

  return (
    <div className="annotation-popup">
      <ul className="annotation_menu">
        {!annotation.isOverlappedSelection && (
          <Fragment>
            <li className="highlight_wrapper">
              Highlight2:{" "}
              {!annotation.shareable && (
                <>
                  <span
                    className="yellow"
                    onClick={(): void => {
                      setAnnotationColor(AnnotationColors.Yellow);
                    }}
                  >
                    Brown
                  </span>
                  <span
                    className="green"
                    onClick={(): void => {
                      setAnnotationColor(AnnotationColors.Green);
                    }}
                  >
                    Green
                  </span>
                  <span
                    className="pink"
                    onClick={(): void => {
                      setAnnotationColor(AnnotationColors.Pink);
                    }}
                  >
                    Pink
                  </span>
                </>
              )}
              <span
                className="blue"
                onClick={(): void => {
                  setAnnotationColor(AnnotationColors.Blue);
                }}
              >
                Blue
              </span>
            </li>

            {annotation.annotationId && annotation.noteText ? (
              <li>
                <span
                  onClick={(): void => {
                    toggleNotesPopup(true);
                  }}
                >
                  Edit Note
                </span>
              </li>
            ) : (
              <li>
                <span
                  onClick={(): void => {
                    toggleNotesPopup(true);
                  }}
                >
                  New Note
                </span>
              </li>
            )}

            {annotation.annotationId && (
              <li>
                <span onClick={deleteAnnotation}>
                  {annotation.noteText ? (
                    <Fragment>Delete Highlight and Notes</Fragment>
                  ) : (
                    <Fragment>Delete Highlight</Fragment>
                  )}
                </span>
              </li>
            )}
          </Fragment>
        )}
        <li>
          <span onClick={openNewFlashcardPopup}>New Flash Card</span>
        </li>
        <li>
          <span className="disabled">Search Selection</span>
        </li>
      </ul>
    </div>
  );
};
